import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import SubscriptionPartnerSettings from '../../models/subscription/SubscriptionPartnerSettings';

export interface GetDryRunReportPayload {
  apiKey: string;
  emailCc?: string;
  partner_settings: SubscriptionPartnerSettings
}

export interface GetDryRunReportResponse {
  success: boolean;
  dryRunId: string;
  status: string;
  message: string;
  subscriptionId: string;
}

async function getDryRunReport(
  payload: GetDryRunReportPayload,
  auth: Authentication
): Promise<GetDryRunReportResponse> {
  console.log(payload);
  try {
    return await HttpClient.post('/integrations/contacts/generate-dry-run-report', payload, auth.token, false, {
      'x-api-key': payload.apiKey,
    });
  } catch (e: any) {
    console.log('error: ', e);

    const errorMessage = e.message || 'Unknown error';
    throw new GetDryRunReportFailure(errorMessage, 'import-error');
  }
}

class GetDryRunReportFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getDryRunReport;